import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import Checkbox from "@mui/material/Checkbox";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";

import { BlueprintInfo } from "core/blueprint/base/BlueprintService";
import {
	getBlueprintLink,
	getBlueprintTypeString
} from "core/blueprint/base/Utils";

export type BlueprintRowProps = {
	blueprint: BlueprintInfo;
	selected: boolean;
	showLibraryStatus?: boolean;

	onSelect: (checked: boolean) => void;
};

const BlueprintRow: React.FC<BlueprintRowProps> = (
	props: BlueprintRowProps
) => {
	const { t } = useTranslation();

	return (
		<TableRow>
			<TableCell align="center" padding="checkbox">
				<Checkbox
					checked={props.selected}
					onChange={(_event, checked) => props.onSelect(checked)}
				/>
			</TableCell>
			<TableCell sx={{ width: "20ch" }}>
				{t(getBlueprintTypeString(props.blueprint.type))}
			</TableCell>
			<TableCell
				sx={{
					paddingTop: 0,
					paddingBottom: 0,
					alignContent: "center"
				}}>
				<Link
					to={getBlueprintLink(
						props.blueprint.id,
						props.blueprint.type
					)}>
					{props.blueprint.name}
				</Link>
			</TableCell>
			<TableCell
				sx={{
					paddingTop: 0,
					paddingBottom: 0,
					alignContent: "center"
				}}>
				{t(props.blueprint.description)}
			</TableCell>
			<TableCell padding="none">
				{props.showLibraryStatus && props.blueprint.library && (
					<PublicOutlinedIcon
						fontSize="small"
						sx={{ verticalAlign: "middle" }}
					/>
				)}
			</TableCell>
		</TableRow>
	);
};

export default BlueprintRow;
